module.exports = __webpack_public_path__ + "img/thumbnail_Gemsbok_j_normal.21eb2f28.png";